<template>
  <div>
    <div class="panel-main-content-height" v-if="!detail_grade">
      <header class="page-header page-header-collapsed">
        <div class="page-title-wrapper">
          <a class="button button--icon -inverse previous-panel has-tooltip" id="tooltip-back" @click="$emit('back')">
            <i class="isax isax-arrow-left"></i>
          </a>
          <b-tooltip target="tooltip-back" triggers="hover">
            {{ $t("sessions.reports.backward") }}
          </b-tooltip>
          <h1 class="page-title">{{ $t("sessions.gradeattendancemodal.attendancemodal.title") }} {{ selected }}</h1>
        </div>
        <button class="bb-close" v-on:click="$emit('hide')">
          <span>{{ $t("buttons.close") }}</span><i class="isax isax-close-circle"/>
        </button>
      </header>
      <div class="mt-5">
        <span class="span-assistants-number">
          {{ $t("sessions.gradeattendancemodal.pregrade.attendeestit") }} {{ attendees_reports_rows }}
        </span>
      </div>
      <div id="body-content" class="body-content instances-container" style="overflow-y: auto;">
        <table v-if="paginated_attendees_reports.length > 0 && gradable_activities.length > 0" class="content-table report-table">
          <tbody>
            <tr class="content-table__header content-table__header--shadow">
              <th class="checkbox-td-attendee-report">
                <div class="checkbox-wrap checkbox-wrap-all checkbox-wrap-empty-label">
                  <input id="checkbox-all-attendees" name="list_report_check" type="checkbox" checked @change="toggleAllAttendees">
                  <label for="checkbox-all-attendees"></label>
                </div>
              </th>
              <th class="th-order" @click="sort()">
                <span class="span-th-table-attendee-report">
                  {{ $t("sessions.gradeattendancemodal.pregrade.attendees") }}
                  <chevron-up-icon v-if="sortActive && sortOrder === 'asc'"></chevron-up-icon>
                  <chevron-down-icon v-else-if="sortActive && sortOrder === 'desc'"></chevron-down-icon>
                </span>
              </th>
              <th class="" v-for="activity in gradable_activities" v-bind:key="activity.id">{{ activity.name }}</th>
            </tr>
            <tr v-for="attendee_report in paginated_attendees_reports" v-bind:key="attendee_report.userId" class="element-list-row" bb-attendance-instance-row>
              <td class="checkbox-td-attendee-report">
                <div class="checkbox-wrap checkbox-wrap-empty-label">
                  <input :id="'report-attendee-' + attendee_report.userId" name="checkListAttendeeReport" type="checkbox" v-model="attendee_report.checked">
                  <label :for="'report-attendee-' + attendee_report.userId"></label>
                </div>
              </td>
              <td>
                <span>{{ attendee_report.fullName }}</span>
              </td>
              <td v-for="attendance_grade in attendee_report.attendanceGrades" v-bind:key="attendance_grade.id">
                <span>{{ attendance_grade.grade }}%</span>
              </td>
              <td>
                <button class="button--text text-decoration-none" @click="showDetail (attendee_report)">
                  {{ $t("sessions.gradeattendancemodal.pregrade.seedetail") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!paginated_attendees_reports.length > 0" class="no-content no-results">
          <span class="no-content-title">{{ $t("sessions.gradeattendancemodal.pregrade.noresults") }}</span>
        </div>
        <div v-if="!gradable_activities.length > 0" class="no-content no-results">
          <span class="no-content-title">{{ $t("sessions.gradeattendancemodal.pregrade.nogradableactivities") }}</span>
        </div>
        <div>
          <button class="page-controls__primary-action button primary short gradebutton" @click="confirmGrade()" v-if="paginated_attendees_reports.length > 0 && showCalificator != 'straining'">
            <span>{{ $t("sessions.gradeattendancemodal.pregrade.startgrade") }}</span>
          </button>
        </div>
        <div class="d-flex justify-content-center">
          <b-pagination
            v-if="attendees_reports_rows > attendees_reports_pagination.limit"
            v-model="attendees_reports_pagination.currentPage"
            :total-rows="attendees_reports_rows"
            :per-page="attendees_reports_pagination.limit"
          ></b-pagination>
        </div>
      </div>
    </div>
    <DetailGrade v-if="detail_grade" :classrooms="classrooms" :gradable_activities="gradable_activities" :selected="selected" :attendee_reports_detail="attendee_reports_detail" @back="hideDetail" @hide="$emit('hide')"/>
  </div>
</template>
<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import KeyboardReturnIcon from 'vue-material-design-icons/KeyboardReturn.vue'
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import jwtMixin from '../../../mixins/jwtMixin'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import ltiFrameMixin from '../../../mixins/ltiFrameMixin'
import DetailGrade from './DetailGrade'

export default {
  name: 'PreGrade',
  components: {CloseIcon, KeyboardReturnIcon, ChevronDownIcon, ChevronUpIcon, ChevronRightIcon, DetailGrade},
  mixins: [jwtMixin, utilitiesMixin, ltiFrameMixin],
  props: ['classrooms', 'gradable_activities', 'selected', 'selectedId'],
  mounted () {
    this.$moment.locale('es')
    this.getAteendeesReports()
  },
  created () {
    this.$i18n.locale = this.jwtLanguage()
  },
  data () {
    return {
      detail_grade: false,
      attendees_reports: [],
      attendees_reports_view: [],
      attendee_reports_detail: [],
      attendees_reports_pagination: {
        limit: 10,
        currentPage: 1
      },
      attendee_reports_detail_pagination: {
        limit: 10,
        currentPage: 1
      },
      sortActive: true,
      sortOrder: 'desc',
      view_detail: false,
      showCalificator: this.jwtConsumerCode()
    }
  },
  computed: {
    attendee_reports_detail_rows () {
      return this.attendee_reports_detail.length
    },
    attendees_reports_rows () {
      return this.attendees_reports_view.length
    },
    sorted_attendees_reports () {
      if (!this.sortActive) {
        return this.attendees_reports_view
      }
      let items = [...this.attendees_reports_view]
      let order = this.sortOrder === 'asc' ? 1 : -1
      items.sort((a, b) => (a.fullName.localeCompare(b.fullName) * order))
      return items
    },
    paginated_attendees_reports () {
      let start = (this.attendees_reports_pagination.currentPage - 1) * this.attendees_reports_pagination.limit
      let end = start + this.attendees_reports_pagination.limit
      return this.sorted_attendees_reports.slice(start, end)
    },
    sorted_attendee_reports_detail () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.attendee_reports_detail.sort((a, b) => new Date(b.classroomStart) - new Date(a.classroomStart))
    },
    paginated_attendee_reports_detail () {
      let start = (this.attendee_reports_detail_pagination.currentPage - 1) * this.attendee_reports_detail_pagination.limit
      let end = start + this.attendee_reports_detail_pagination.limit
      return this.sorted_attendee_reports_detail.slice(start, end)
    },
    dataLicenceTyoe () {
      return this.showCalificator
    }
  },
  methods: {
    async getAteendeesReports () {
      let vueComponent = this
      this.attendees_reports = []
      let promises = []

      // Por cada clase seleccionada se obtienen las asistencias cualificadas usando el nuevo endpoint
      for (let classroom of this.classrooms.filter(c => c.checked)) {
        promises.push(
          window.axios.get('dbreports/' + classroom.id + '/attendanceQualified', {
            params: { group: vueComponent.selectedId }
          }).then(response => {
            // Solo se procesan los participantes (no moderadores ni presentadores)
            response.data
              .filter(attendee => attendee.roleCode === 'PARTICIPANT')
              .forEach(attendee => {
                const grades = vueComponent.calculateGrades(attendee.attendanceQualified)
                vueComponent.attendees_reports.push({
                  ...attendee,
                  attendanceGrades: { grade: grades.grade },
                  classroomId: classroom.id,
                  classroomName: classroom.name,
                  classroomStart: classroom.start,
                  checked: true
                })
              })
          })
        )
      }

      await Promise.all(promises)
      vueComponent.getAttendeesReportsView()
    },
    getAttendeesReportsView () {
      this.attendees_reports_view = []
      let totalGradesLength = this.gradable_activities.length
      let vueComponent = this
      let proccesedUser = {}
      // Se ordenan por nota descendente para asignar la mejor calificación a la primera actividad
      let attendeesReporsOrderGrade = vueComponent.attendees_reports.sort((a, b) => b.attendanceGrades.grade - a.attendanceGrades.grade)
      attendeesReporsOrderGrade.forEach(ar => {
        if (!proccesedUser[ar.userId]) {
          let attendeeReport = {...ar}
          attendeeReport.attendanceGrades = [attendeeReport.attendanceGrades]
          vueComponent.attendees_reports_view.push(attendeeReport)
          proccesedUser[ar.userId] = true
        } else {
          vueComponent.attendees_reports_view.filter(arv => arv.userId === ar.userId &&
            arv.attendanceGrades.length < totalGradesLength).forEach(arv => {
            arv.attendanceGrades.push(ar.attendanceGrades)
            arv.attendanceGrades.sort((a, b) => b.grade - a.grade)
          })
        }
      })
      vueComponent.attendees_reports_view.forEach(arv => {
        while (arv.attendanceGrades.length < totalGradesLength) {
          arv.attendanceGrades.push({ grade: 0 })
        }
      })
    },
    confirmGrade () {
      let vueComponent = this
      let checkListAttendeeReport = document.getElementsByName('checkListAttendeeReport')
      let oneReportChecked = false
      for (var i = 0; i < checkListAttendeeReport.length; i++) {
        if (checkListAttendeeReport[i].checked === true) {
          oneReportChecked = true
          break
        }
      }
      if (oneReportChecked === true) {
        this.$confirm(
          {
            title: this.$t('sessions.gradeattendancemodal.popuconfirm.title'),
            message: this.$t('sessions.gradeattendancemodal.popuconfirm.description'),
            button: {
              no: this.$t('buttons.cancel'),
              yes: this.$t('sessions.gradeattendancemodal.popuconfirm.title')
            },
            callback: confirm => {
              if (confirm) {
                vueComponent.grade()
                let consumerCode = vueComponent.jwtConsumerCode()
                if (consumerCode != null && consumerCode === 'canvas') {
                  vueComponent.$noty.success(vueComponent.$i18n.t('sessions.gradeattendancemodal.popuconfirm.confirmnotice'), {
                    timeout: 3000,
                    progressBar: true
                  })
                } else if (consumerCode != null && consumerCode === 'moodle') {
                  vueComponent.$noty.success(vueComponent.$i18n.t('sessions.gradeattendancemodal.popuconfirm.confirmnoticemoodle'), {
                    timeout: 3000,
                    progressBar: true
                  })
                }
              }
            }
          }
        )
      } else {
        vueComponent.$noty.error(vueComponent.$i18n.t('sessions.gradeattendancemodal.popuconfirm.noattendeselected'), {
          timeout: 3000,
          progressBar: true
        })
      }
    },
    async grade () {
      let vueComponent = this
      const licenceId = this.jwtConsumerId()
      for (let i = 0; i < vueComponent.gradable_activities.length; i++) {
        let studentsGrades = {}
        studentsGrades.studentGrades = []
        studentsGrades.activityPoints = vueComponent.gradable_activities[i].points
        for (let j = 0; j < vueComponent.attendees_reports_view.length; j++) {
          if (vueComponent.attendees_reports_view[j].checked) {
            let unirId = vueComponent.attendees_reports_view[j].unirId
            if (vueComponent.attendees_reports_view[j].unirType === 'P') {
              unirId = 'PT-' + unirId
            }
            if (vueComponent.attendees_reports_view[j].attendanceGrades[i].grade === 100) {
              studentsGrades.studentGrades.push({grade: studentsGrades.activityPoints, unirId: unirId})
            }
          }
        }

        if (studentsGrades.studentGrades.length > 0) {
          window.axios.put('licences/' + licenceId + '/grades/' + vueComponent.gradable_activities[i].id, studentsGrades)
        }
      }
      vueComponent.$emit('back')
    },
    getAteendeeReportsDetail (attendeeReport) {
      this.attendee_reports_detail = []
      let vueComponent = this
      vueComponent.attendees_reports.forEach(ar => {
        if (ar.userId === attendeeReport.userId) {
          vueComponent.attendee_reports_detail.push(ar)
        }
      })
    },
    toggleAllAttendees (event) {
      this.attendees_reports_view.forEach(ar => {
        ar.checked = event.target.checked
      })
    },
    sort () {
      if (this.sortActive) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortActive = true
        this.sortOrder = 'asc'
      }
    },
    // Ver GradeAttendanceSidebar.showPreGrade: el cambio de vista dentro del panel no
    // dispara ningún evento de b-sidebar, así que el scroll se pide a mano.
    showDetail (attendeeReport) {
      this.view_detail = true
      this.detail_grade = true
      this.getAteendeeReportsDetail(attendeeReport)
      this.scrollLtiFrameToTop()
    },
    hideDetail () {
      this.view_detail = false
      this.detail_grade = false
      this.scrollLtiFrameToTop()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsModals/PreGrade.vue